module.exports = __webpack_public_path__ + "assets/travel_tracker_white.19c8292d.svg";